import { IRequest } from '@r1-frontend/shared/types/IRequest';

import { IRegion } from './dto/ResponseDto';

// при расширении признаков группировки на бэке добавить сюда варианты группировки
type TGroupRegionsBy = 'firstChar';

interface IRequestParams {
    sortBy?: keyof IRegion,
    groupBy?: TGroupRegionsBy,
}

/**
 * Конфигурация запроса получения регионов
 * https://master.api-content.sandbox.d2c.r-one.io/docs/v1#/%D0%93%D0%95%D0%9E/02f89bce1a45c3bdc4b5012c0d245869
 */
export const getRegionsGroups = (providerId: number, queryParams: IRequestParams): IRequest => ({
    uri: '/v1/geography/get-regions',
    method: 'GET',
    headers: { 'ProviderId': `${providerId}` },
    queryParams,
});

